<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn :to="{ name: 'Reports' }" color="primary" outlined right fab small class="mr-4"><v-icon>mdi-close</v-icon></v-btn>
      <div class="title primary--text">{{ section }}</div>
    </div>

    <v-flex xs12>
      <v-card class="mx-auto mt-5" tile>
        <template>
          <v-container fluid class="mb-0 pb-0">
            <v-row>

              <!-- Filtro por forma de pago y platillo -->
              <v-col cols="12" md="3">
                <v-tabs
                  v-model="tab"
                  left
                  class="tab-custom">
                  <v-tab v-for="item in items" :key="item.tab" class="caption">{{ item.tab }}</v-tab>
                </v-tabs>
              </v-col>

              <!-- Filtro por periodo -->
              <v-col cols="12" md="6" class="text-right pb-0 pt-5">
                <date-tab-filter :dates="dates" :period="period" v-on:update:filter="filter = $event" v-on:update:period="period = $event" v-on:update:dates="dates = $event"></date-tab-filter>
              </v-col>

              <!-- Filtro por rango de fecha -->
              <v-col cols="12" md="3" class="pb-0 pt-1 text-right">
                <date-filter :dates="dates" :filter="filter" v-on:update:change="dates = $event"></date-filter>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <v-card flat>
                <component :is="item.component" :period="period" :dates="dates">
                  <router-view></router-view>
                </component>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </template>
      </v-card>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import DateTabFilter from '../components/DateTabFilter.vue'
import DateFilter from '../components/DateFilter'
import ByPaymentMethod from './components/ByPaymentMethod'
import PerDish from './components/PerDish'
export default {
  name: 'sales-after-tax',
  components: {
    DateTabFilter,
    DateFilter,
    'by-payment-method': ByPaymentMethod,
    'per-dish': PerDish
  },
  data () {
    return {
      section: this.$i18n.t('reports.afterTaxSales'),
      overlay: false,
      filter: 0,
      dates: [],
      period: 'week',
      tab: null,
      items: [
        { tab: 'Por forma de pago', component: 'by-payment-method' },
        { tab: 'Por platillo', component: 'per-dish' }
      ]
    }
  },
  computed: {
    queryParams () {
      const { dates, period } = this.$route.query
      return { dates, period }
    }
  },
  async mounted () {
    this.dates = this.queryParams.dates
    this.period = this.queryParams.period
  }
}
</script>
